<template>
  <div class="form-row d-info admin-info">
    <p>
      <sup>(1)</sup> Wpłaty za doładowanie licznika energetycznego online obsługiwane są przez Autopay Spółka Akcyjna z siedzibą w Sopocie przy ul. Powstańców Warszawy 6, 81-718 Sopot, wpisaną do rejestru przedsiębiorców prowadzonego przez Sąd Rejonowy Gdańsk-Północ w Gdańsku, VIII Wydział Gospodarczy Krajowego Rejestru Sądowego pod numerem KRS 0000320590, NIP 585-13-51-185, Regon 191781561, o kapitale zakładowym w wysokości 2 205 500 PLN (w całości opłaconym), nadzorowaną przez Komisję Nadzoru Finansowego i wpisaną do rejestru krajowych instytucji płatniczych pod numerem IP17/2013. Autopay S.A. zapewnia najwyższy poziom bezpieczeństwa realizowanych transakcji.
    </p>
  </div>
</template>

<script>
export default {
  name: 'AdministratorDataInfo',
  data () {
    return {
      showMore: false
    }
  }
}
</script>
